import React from "react";
import "./style.less";

const HomeInstruction = (props) => {

  return (
    <div>
      <div className="block-header">
        <h3>充电使用说明</h3>
      </div>

      <div className="instruction-wrapper">
        <ul>
          <li>① 先将充电器与电瓶车连接牢靠。</li>
          <li>② 再将充电器插头插在空闲插座上。</li>
          <li>③ 打开手机扫描二维码（或刷IC卡），下单开始充电。</li>
          <li>④ 充电完成后，请将车辆移出充电区，方便他人充电。</li>
        </ul>
        <br />
        <p>友情提示：车辆充满后自动断电且退费，请放心使用！</p>
      </div>
    </div>
  )
}

export default HomeInstruction